import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { VerMapaPage } from '../vermapa/vermapa';
import { AddDadosPage } from '../dados/adddados';

@Component({
  selector: 'escolhersintoma',
  templateUrl: 'escolhersintoma.html'
})
export class EscolherSintomaPage {

	public verMapaPage = VerMapaPage;
	public sintomas: any[] = [];
	public coord;
	public coord2;
	public coord3;
	public cidade;
	public cidade2;
	public cidade3;
	public estado;
	public estado2;
	public estado3;
	public user;
	public dependente;
	public sintomasEscolhidos: Array<number> = [];

	public sintomasEscolhidosNomes = [];
	public newData = [];

	sintomasFiltrados: string = '';

	constructor(public navCtrl: NavController, public navParams: NavParams, private http: Http, private alertCtrl: AlertController) {
 		this.coord = navParams.get("coord");
 		this.coord2 = navParams.get("coord2");
 		this.coord3 = navParams.get("coord3");
	   	this.cidade = navParams.get("cidade");
	   	this.cidade2 = navParams.get("cidade2");
	   	this.cidade3 = navParams.get("cidade3");
	   	this.estado = navParams.get("estado");
	   	this.estado2 = navParams.get("estado2");
	   	this.estado3 = navParams.get("estado3");
	    this.user = navParams.get("user");
	   	this.dependente = navParams.get("dependente");
	}

	ionViewWillLoad(){
	    this.getData();
	}

	getData(){
		this.respGetData('').subscribe(data => {
			this.sintomas = data;
		});
	}

	filtrar(){
		this.respGetData(this.sintomasFiltrados).subscribe(data => {

			this.newData = [];

			for(var i = 0; i <= data.length-1; i++){

				var id = data[i].id;

				if(this.sintomasEscolhidos.indexOf(id) === -1){
					this.newData.push(data[i]); 
				}
			}
			
			this.sintomas = this.newData;
		});
	}

	addSintomaArray(id, nome){

		let index = this.sintomasEscolhidos.indexOf(id);
		let sintoma = {
			id: id,
			nome: nome
		};
		
		if(index > -1){

			this.sintomasEscolhidos.splice(index, 1);
			this.sintomasEscolhidosNomes.splice(index, 1);

			document.getElementById(nome).removeAttribute("style"); 

		} else {

			if(this.sintomasEscolhidosNomes.length >= 5) {
				let alert = this.alertCtrl.create({
					subTitle: 'Máximo de 5 sintomas.',
					buttons: ['OK']
				});
				
				alert.present();
				return;
			}

			this.sintomasEscolhidos.push(id);

			this.sintomasEscolhidosNomes.push(sintoma);
			document.getElementById(nome).style.display = 'none';
		}
	}

	respGetData(nome): Observable<any> {
    	return this.http.get("http://maisalguemdoente.com.br/sintomas/webService/getSintoma?nome="+nome).map((res: Response) => res.json());
  	}

  	addDados(){
  		if(this.sintomasEscolhidos.length < 1){
  			let alert = this.alertCtrl.create({
		        subTitle: 'Selecione pelo menos um sintoma.',
		        buttons: ['OK']
			});
      		alert.present();
  		} else {
	  		this.navCtrl.push(AddDadosPage, {
		      coord: this.coord,
		      coord2: this.coord2,
		      coord3: this.coord3,
		      cidade: this.cidade,
		      cidade2: this.cidade2,
		      cidade3: this.cidade3,
		      estado: this.estado,
		      estado2: this.estado2,
		      estado3: this.estado3,
		      user: this.user,
		      dependente: this.dependente,
		      sintomas: this.sintomasEscolhidos
		    });
  		}
  	}
}


// WEBPACK FOOTER //
// ./src/pages/sintomas/escolhersintoma.ts